<script setup lang="ts">
import { computed, inject } from 'vue';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';

interface Props {
  ratings?: UserRating[]
  isOpen: boolean
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (e: 'close'): void
}>();

function closeModal() {
  emit('close');
}

const user = inject<User>('user');

const ratingsWithDescription = computed(() => props.ratings?.filter((rating) => !!rating.description));
</script>
<template>
  <base-modal
    :open="isOpen"
  >
    <div class="flex w-full flex-col space-y-4">
      <button
        type="button"
        class="absolute self-end"
        @click="closeModal"
      >
        <img
          src="@/assets/icons/close.svg"
          class="h-5 w-5"
        >
      </button>
      <img
        v-if="user?.picture.webpSm.url"
        :src="user?.picture.webpSm.url"
        class="h-24 w-24 self-center rounded-full object-cover"
      >
      <img
        v-else
        src="@/assets/icons/default-profile.svg"
        class="h-24 w-24 rounded-full object-cover"
      >
      <p class="text-lg font-bold text-z-gray-900">
        {{ user?.firstName }} {{ user?.lastName }}
      </p>
      <div class="space-y-2">
        <p class="text-z-gray-900">
          Calificaciones ({{ ratings?.length ?? 0 }})
        </p>
        <base-stars :value="user?.ratingAverage" />
      </div>
      <p>Opiniones ({{ ratingsWithDescription?.length ?? 0 }})</p>
      <div class="space-y-4 overflow-y-scroll scrollbar-hide">
        <div
          v-for="rating in ratingsWithDescription"
          :key="rating.id"
          class="flex space-x-6 rounded-lg border border-z-gray-100 px-4 py-3"
        >
          <img
            v-if="rating.senderPicture"
            :src="rating.senderPicture"
            class="h-10 w-10 self-center rounded-full object-cover"
          >
          <img
            v-else
            src="@/assets/icons/default-profile.svg"
            class="h-10 w-10 rounded-full object-cover"
          >
          <div class="flex flex-col space-y-1">
            <p class="text-sm font-medium italic text-z-gray-800">
              "{{ rating.description }}"
            </p>
            <p class="text-sm font-medium text-z-gray-500">
              {{ rating.senderName }}
            </p>
            <p class="font-light text-z-gray-500">
              hace {{ formatDistanceToNow(new Date(rating.createdAt)) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </base-modal>
</template>
